// 播放器组件
import Player from "xgplayer";
import HlsJsPlayer from "xgplayer-hls.js";
import micromatch from "micromatch";


// 判断url类型
export default function initPlayer(el, url, poster = "", autoPlay = true, isLive = false) {
    const url_res = new URL(url);

    // 如果是判断url结尾
    const res_mp4 = micromatch.contains(url_res.pathname, "*.mp4");
    const res_m3u8 = micromatch.contains(url_res.pathname, "*.m3u8");
    console.log("视频url", el, url, poster, autoPlay, res_mp4, res_m3u8);
    if (res_mp4) {
        new Player({
            "el": el,
            "url": url,
            "playsinline": true,
            "fluid": true,
            "autoplay": autoPlay,
            width: 720,
            height: 422,
            poster,
            'x5-video-player-fullscreen': true
        });
    } else if (res_m3u8) {
        new HlsJsPlayer({
            "el": el,
            "url": url,
            "playsinline": true,
            "fluid": true,
            "autoplay": autoPlay,
            width: 720,
            height: 422,
            poster,
            'x5-video-player-fullscreen': true,
            isLive: isLive, //直播场景设置为true
            //useHls: false,
        })
    }



}